import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5","key":"svg-0"}],["path",{"d":"M11 21h-3a4 4 0 0 1 -4 -4v-1a8 8 0 0 1 14.376 -4.833","key":"svg-1"}],["path",{"d":"M18.42 15.61a2.1 2.1 0 1 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39","key":"svg-2"}]]

const IconMoneybagEdit = createReactComponent('outline', 'moneybag-edit', 'MoneybagEdit', __iconNode);

export default IconMoneybagEdit;